// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import type {Spec} from 'immutability-helper';
import $ from 'jquery';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {assert} from 'Asserts';
import {Permissions} from 'auth/PermissionConstants';
import * as benchlingUtil from 'BenchlingUtil';
import {EventConstants} from 'constants/EventConstants';
import {User} from 'constants/UserConstants';
import * as context from 'Context';
import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import {SchemaTag} from 'folder-items/FileConstants';
import AppDispatcher from 'lib/Dispatcher';
import type {Protocol, ProtocolSummary} from 'notebook/ELNConstants';
import type {SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import ProtocolDAO from 'notebook/protocols/dao/ProtocolDAO';
import type {ProtocolStoreTransformsProtocol} from 'notebook/protocols/ProtocolStoreTransforms';
import EditorStore from 'notebook/protocols/stores/EditorStore';
import {ACTION_RESET_VERSION} from 'notebook/store/VersioningConstants';
import notifications from 'notifications';

interface ProtocolPostServerUpdate {
  archiveRecord?: ArchiveRecord | null;
  authors?: Array<User>;
  permissions?: Permissions;
  tags?: Array<SchemaTag>;
}

const EditorActions = {
  async bulkFetchSummaries(this: void, protocolIds: Array<string>): Promise<Record<string, ProtocolSummary>> {
    const {fileSummariesById} = (await FileBrowserDAO.bulkFetchFileSummaries(protocolIds))!;
    return fileSummariesById as unknown as Record<string, ProtocolSummary>;
  },

  print(protocolID: string): void {
    const state = EditorStore.getEditorState(protocolID)!;
    const versionId = state.openVersionId;
    window.open(`view?versionId=${versionId}#print`, '_blank');
  },

  update(protocolID: string, op: Spec<Protocol>, {bumpVersion = true}: {bumpVersion?: boolean} = {}): void {
    // Merge in the changes into the open protocol, client-side.
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_UPDATE,
      protocolID,
      op,
      cidIdMap: {},
      bumpVersion,
    });
  },

  postServerUpdate(protocolID: string, data: ProtocolPostServerUpdate): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_UPDATE,
      protocolID,
      op: {$merge: data},
      cidIdMap: {},
      bumpVersion: false,
    });
  },

  revert(
    protocolID: string,
    protocol: ProtocolStoreTransformsProtocol,
    restoreData: SelectionRestoreData
  ): void {
    // Replace the open protocol with the specified data.
    // Useful to reset the state to an older state.
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_REPLACE,
      protocolID,
      protocol,
      restoreData,
    });
  },

  loadVersion(protocolID: string, versionId: string | number): void {
    // HistoryPanelComponent.openVersion is string | number. ProtocolDAO.getVersion and
    // EDITOR_LOAD_VERSION* payloads require number. Number(versionId) would change identity
    // for string ids (`===` in VersionedItemSubstore._updateVersion), so the mismatch is
    // suppressed instead of coerced.
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_LOAD_VERSION,
      protocolID,
      // @ts-expect-error ts(2322)
      versionId,
    });
    // @ts-expect-error ts(2345)
    ProtocolDAO.getVersion(protocolID, versionId)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_LOAD_VERSION_COMPLETED,
          protocolID,
          // @ts-expect-error ts(2322)
          versionId,
          version: response!,
        });
      })
      .fail((response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_LOAD_VERSION_FAILED,
          protocolID,
          // @ts-expect-error ts(2322)
          versionId,
        });
      });
  },

  fetchVersions(protocolID: string): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_FETCH_VERSIONS,
      protocolID,
    });
    ProtocolDAO.getVersions(protocolID)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_FETCH_VERSIONS_COMPLETED,
          protocolID,
          versions: response!,
        });
      })
      .fail((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_FETCH_VERSIONS_FAILED,
          protocolID,
        });
      });
  },

  resetToOpenVersion(protocolID: string): void {
    const {isLatest} = EditorStore.getEditorState(protocolID)!;
    assert(!isLatest, 'Unexpected reset version while on latest version');
    context.using({immediateAutoSaverQueueSaveAction: ACTION_RESET_VERSION}, this, () => {
      AppDispatcher.dispatch({
        actionType: EventConstants.EDITOR_RESET_TO_OPEN_VERSION,
        protocolID,
      });
    });
  },

  save(protocolID: string): JQueryPromise<boolean> {
    // Create a deferred promise that will be resolved once the save has completed.
    const deferredPromise = $.Deferred<boolean>();
    benchlingUtil.asyncThrottle(`protocol-save-${protocolID}`, () => {
      const {protocol, openVersion} = EditorStore.getEditorState(protocolID)!;

      // Avoid doing a save if the protocol is already up-to-date.
      if (!EditorStore.hasUnsavedChanges(protocolID)) {
        return deferredPromise.resolve(false).promise();
      }

      const serverProtocol = EditorStore.prepareForSave(protocolID, protocol);

      AppDispatcher.dispatch({
        actionType: EventConstants.EDITOR_SAVE,
        protocolID,
      });

      const xhr = ProtocolDAO.update(protocolID, serverProtocol)
        .done((response) => {
          EditorActions.fetchVersions(protocolID);
          AppDispatcher.dispatch({
            actionType: EventConstants.EDITOR_SAVE_COMPLETED,
            protocolID,
            savedVersion: openVersion,
            versionId: response!.cidIdMap[serverProtocol.cid!] as number,
            cidIdMap: response!.cidIdMap,
            serverData: {
              editURL: response!.editURL,
            },
          });
          // Resolve the deferred promise to signal that the save has completed.
          deferredPromise.resolve(true);
        })
        .fail((response) => {
          notifications.stickyNotifyForFriendlyError(response, 'protocol-save-fail');
          AppDispatcher.dispatch({
            actionType: EventConstants.EDITOR_SAVE_FAILED,
            protocolID,
            error: response!,
          });
          // Resolve the deferred promise to signal that the save has failed.
          deferredPromise.resolve(false);
        });
      return xhr;
    });
    // Return the deferred promise so that the caller can wait for the save to complete.
    return deferredPromise.promise();
  },

  // TODO(T1135): Don't pass in deferred. Note: Only ProxyFile should be passing in deferred.
  open(protocolID: string, param?: {deferred?: JQueryDeferred<void>}): void {
    if (param == null) {
      param = {};
    }
    const {deferred} = param;
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_OPEN,
      protocolID,
    });
    ProtocolDAO.get(protocolID)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_OPEN_COMPLETED,
          protocolID,
          protocol: response,
        });
        EditorActions.fetchVersions(protocolID);
        if (deferred != null) {
          deferred.resolve();
        }
      })
      .fail((response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_OPEN_FAILED,
          protocolID,
          error: response!,
        });
        if (deferred != null) {
          deferred.reject(response);
        }
      });
  },

  close(protocolID: string): void {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_CLOSE,
      protocolID,
    });
  },
};

export default EditorActions;
